(function(){
  function init(root){
    if(root.dataset.kogReady) return;
    root.dataset.kogReady='true';
    var cards=[].slice.call(root.querySelectorAll('[data-kog-card]'));
    var dots=[].slice.call(root.querySelectorAll('[data-kog-dot]'));
    var methodButtons=[].slice.call(root.querySelectorAll('[data-kog-select-method]'));
    var copyPanels=[].slice.call(root.querySelectorAll('[data-kog-copy-panel]'));
    var stage=0, method=0, timer=null, visible=false;
    var methodNames=['fresh','nespresso','dolce'];
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay=root.dataset.autoplay==='true'&&!reduced;
    var allVideos=[].slice.call(root.querySelectorAll('video'));

    function preloadAll(){
      allVideos.forEach(function(video){
        if(video.preload!=='auto'){
          video.preload='auto';
          video.load();
        }
      });
    }

    function activeVideo(){return cards[stage].querySelector('video.is-active, video:not([data-kog-method])');}
    function playActive(){
      cards.forEach(function(card,i){card.querySelectorAll('video').forEach(function(v){if(i!==stage||!v.classList.contains('is-active')&&v.hasAttribute('data-kog-method')){v.pause();}});});
      var video=activeVideo();
      if(video&&visible){video.preload='auto';video.currentTime=0;video.play().catch(function(){});}
    }
    function render(){
      cards.forEach(function(card,i){card.classList.toggle('is-active',i===stage);card.classList.toggle('is-before',i<stage);});
      dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===stage);});
      copyPanels.forEach(function(panel,i){panel.classList.toggle('is-active',i===stage);});
      methodButtons.forEach(function(button,i){button.classList.toggle('is-active',i===method);});
      cards[0].querySelectorAll('[data-kog-method]').forEach(function(video){video.classList.toggle('is-active',video.dataset.kogMethod===methodNames[method]);});
      playActive();schedule();
    }
    function schedule(){
      clearTimeout(timer);if(!autoplay||!visible||document.hidden)return;
      var video=activeVideo();var delay=video&&isFinite(video.duration)&&video.duration>0?Math.max(2600,video.duration*1000+350):4300;
      if(stage===1)delay=9500;if(stage===2)delay=9000;
      timer=setTimeout(advance,delay);
    }
    function advance(){if(stage===0&&method<2){method++;}else if(stage===0){stage=1;method=0;}else if(stage===1){stage=2;}else{stage=0;method=0;}render();}
    function setStage(next){stage=(next+cards.length)%cards.length;method=0;render();}
    root.querySelector('[data-kog-prev]').addEventListener('click',function(){setStage(stage-1);});
    root.querySelector('[data-kog-next]').addEventListener('click',function(){setStage(stage+1);});
    dots.forEach(function(dot){dot.addEventListener('click',function(){setStage(Number(dot.dataset.kogDot));});});
    methodButtons.forEach(function(button,i){button.addEventListener('click',function(){stage=0;method=i;render();});});
    document.addEventListener('visibilitychange',function(){if(document.hidden){clearTimeout(timer);cards.forEach(function(c){c.querySelectorAll('video').forEach(function(v){v.pause();});});}else{playActive();schedule();}});
    if('IntersectionObserver'in window){
      var preloadObserver=new IntersectionObserver(function(entries){
        if(entries[0].isIntersecting){preloadAll();preloadObserver.disconnect();}
      },{rootMargin:'1200px 0px'});
      preloadObserver.observe(root);
      new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;if(visible){playActive();schedule();}else{clearTimeout(timer);cards.forEach(function(c){c.querySelectorAll('video').forEach(function(v){v.pause();});});}},{rootMargin:'120px 0px'}).observe(root);
    }else{visible=true;preloadAll();}
    render();
  }
  function initAll(scope){(scope||document).querySelectorAll('[data-origin-guide]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();
